import { Divider, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { PrincipalLayouts } from "../../layouts";
import { AdminLPTable } from "../components/divestment/AdminLPTable";
// import { DivestmentLPTable } from "../components/divestment/DivestmentLPTable";
import { AdminFundsTable } from "../components/positions/funds/AdminFundsTable";
import { LPView } from "../components/positions/LPView";
import { fetchData } from "../helpers/getData/fetchData";
import { GetUsers } from "../components/positions/funds/pushNotifications/GetUsers";

export const PositionsLP = () => {
  const { t } = useTranslation("global");
  const { role } = useSelector((state) => state.auth);

  // eslint-disable-next-line no-unused-vars
  const [divestmentLPList, setDivestmentLPList] = useState("isLoading");

  const [divestmentListAdminLP, setDivestmentListAdminLP] =
    useState("isLoading");
  const [fundsList, setFundsList] = useState("isLoading");
  const [reloadData, setReloadData] = useState(false);

  useEffect(() => {
    if (role === "Híbrido" || role === "LP") {
      fetchData(setDivestmentLPList, "/divestmentFund", t);
    }

    if (role === "Admin") {
      fetchData(
        setDivestmentListAdminLP,
        "/divestmentFund/getAllDivestmentFund",
        t
      );
      fetchData(setFundsList, "/funds", t);
    }
  }, [t, role, reloadData]);

  return (
    <PrincipalLayouts>
      <Stack gap={8}>
        {(role === "LP" || role === "Híbrido") && (
          <Stack>
            <Typography
              color="primary"
              component="h2"
              sx={{ typography: { md: "h6", xs: "subtitle1" } }}
            >
              {t("tablestitles.positionLP")}
            </Typography>
            <Divider sx={{ marginBottom: "25px", marginTop: "10px" }} />
            <LPView />
          </Stack>
        )}

        {/* {
                    (divestmentLPList !== 'isLoading' && (role === 'Híbrido' || role === 'LP')) &&
                    <Stack>
                        <Typography color='primary' variant='h6'>{t('tablestitles.divestmentLP')}</Typography>
                        <Divider sx={{ marginBottom: '25px', marginTop: '10px' }} />
                        <DivestmentLPTable rows={divestmentLPList} />
                    </Stack>
                } */}
        {role === "Admin" &&
          divestmentListAdminLP !== "isLoading" &&
          fundsList !== "isLoading" && (
            <Stack gap={8}>
              <AdminFundsTable rows={fundsList} setReloadData={setReloadData} />
              <Stack>
                <Typography color="primary" variant="h6">
                  {t("tablestitles.divestmentLP")}
                </Typography>
                <Divider sx={{ marginBottom: "25px", marginTop: "10px" }} />
                <AdminLPTable
                  rows={divestmentListAdminLP.filter(
                    (divest) => divest.divestmentData.length > 0
                  )}
                  setReloadData={setReloadData}
                />
              </Stack>
              <GetUsers fundsList={fundsList} />
            </Stack>
          )}
      </Stack>
    </PrincipalLayouts>
  );
};
